import { Store } from 'vuex'
const styleAction = 'background: #222; color: #bada55'
const styleMutation = 'background: #222; color: #8EA63C'

export function configureLogging(store: Store<RootState>): Store<RootState> {
  store.subscribeAction((action, state) => {
    const payload = action.payload ? JSON.parse(JSON.stringify(action.payload)) : action.payload
    const stateTemp = JSON.parse(JSON.stringify(state))
    const data = {
      payload: payload,
      state: stateTemp,
    }
    console.log(`%c Action: ${action.type}`, styleAction, data)
  })

  store.subscribe((mutation, state) => {
    const payload = mutation.payload
      ? JSON.parse(JSON.stringify(mutation.payload))
      : mutation.payload
    const stateTemp = JSON.parse(JSON.stringify(state))
    const data = {
      payload: payload,
      state: stateTemp,
    }
    console.log(`%c Mutation: ${mutation.type}`, styleMutation, data)
  })

  return store
}
